import Plyr from 'plyr/dist/plyr.polyfilled.js';

document.addEventListener('turbolinks:load', function() {
  const videos = document.querySelectorAll('.js_plyr_player');
  videos.forEach(function(player) {
    new Plyr(player)
  });
})
